
















































































import { Vue, Prop, Component } from "vue-property-decorator";
import { ContractShort as IContract } from "@/api/models/contract-short";
import { Contractor as IContractor } from "@/api/models/contractor";
import { User as IUser } from "@/api/models/user";
import TableActions from "@/components/form/TableActions.vue";
import DeleteMaterialModal from "@/components/form/DeleteMaterialModal.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";

@Component({
  components: {
    CustomTableCol,
    CustomTableItem,
    DeleteMaterialModal,
    TableActions
  }
})
export default class ContractListItem extends Vue {
  @Prop() contract!: IContract;
  isContractRemoving: boolean = false;
  contractor!: IContractor;
  user!: IUser;

  data() {
    return {
      contractIdForDelete: undefined,
      contractor: undefined,
      user: undefined
    };
  }

  get screenWidth() {
    return window.innerWidth;
  }

  translateName(name: string) {
    if (name === "annex") {
      return `${this.$tc(this.$translate.ContractAddendum)} `;
    } else {
      return `${this.$tc(this.$translate.Contract)} `;
    }
  }

  editContract() {
    this.$router.push({
      name: "contractEdit",
      params: {
        contractId: this.contract.id
      }
    });
  }

  async removeContract() {
    this.isContractRemoving = true;
    this.$store
      .dispatch("contracts/REMOVE", this.contract.id)
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isContractRemoving = false;
      });
  }
}
